// Tilbehør data organized by category
import strompebukser from "@/assets/tilbehor/strompebukser.jpg";
import sko1 from "@/assets/tilbehor/sko-1.jpg";
import sko2 from "@/assets/tilbehor/sko-2.jpg";
import sko3 from "@/assets/tilbehor/sko-3.jpg";
import sko4 from "@/assets/tilbehor/sko-4.jpg";
import sko5 from "@/assets/tilbehor/sko-5.jpg";
import sko6 from "@/assets/tilbehor/sko-6.jpg";
import sko7 from "@/assets/tilbehor/sko-7.jpg";
import sko8 from "@/assets/tilbehor/sko-8.jpg";
import harboyleLundeby from "@/assets/tilbehor/harboyle-lundeby.jpg";
import harbandSvart from "@/assets/tilbehor/harband-svart.jpg";
import harbandBla from "@/assets/tilbehor/harband-bla.jpg";
import belteSvart from "@/assets/tilbehor/belte-svart.jpg";
import belteBla from "@/assets/tilbehor/belte-bla.jpg";
import paraply1 from "@/assets/tilbehor/paraply-1.jpg";
import paraply2 from "@/assets/tilbehor/paraply-2.jpg";
import paraplyer from "@/assets/tilbehor/paraplyer.jpg";
import rengjoring1 from "@/assets/tilbehor/rengjoring-1.jpg";
import rengjoring2 from "@/assets/tilbehor/rengjoring-2.jpg";

export interface TilbehorCategory {
  id: string;
  title: string;
  modalTitle: string;
  description: string;
  images: string[];
}

export const tilbehorCategories: TilbehorCategory[] = [
  {
    id: "sko",
    title: "Sko",
    modalTitle: "Sko",
    description: "Kvalitetssko i ulike stiler som matcher bunaden din.",
    images: [sko1, sko2, sko3, sko4, sko5, sko6, sko7, sko8]
  },
  {
    id: "strompebukser",
    title: "Strømpebukser",
    modalTitle: "Strømpebukser",
    description: "Kvalitetsstrømpebukser i flere farger som passer til bunaden din.",
    images: [strompebukser]
  },
  {
    id: "harboyle",
    title: "Hårbøyler",
    modalTitle: "Hårbøylegraffer",
    description: "Vakre hårbøyler med broderte detaljer for å kompletere bunadantrekket.",
    images: [harboyleLundeby, harbandSvart, harbandBla]
  },
  {
    id: "slips",
    title: "Slips",
    modalTitle: "Slips",
    description: "Elegante slips i tradisjonelle mønstre og farger som passer til bunaden.",
    images: [belteSvart, belteBla]
  },
  {
    id: "paraply",
    title: "Paraplyer",
    modalTitle: "Paraplyer",
    description: "Stilige paraplyer som beskytter bunaden din i all slags vær.",
    images: [paraplyer, paraply1, paraply2]
  },
  {
    id: "rengjoring",
    title: "Rengjøringsprodukter og diverse",
    modalTitle: "Kosprodukter",
    description: "Alt du trenger for å holde bunaden din i perfekt stand gjennom generasjoner.",
    images: [rengjoring1, rengjoring2]
  }
];

// All accessory images for carousel on homepage
export const allTilbehorImages = [
  sko1,
  sko2,
  sko3,
  harboyleLundeby,
  harbandSvart,
  harbandBla,
  belteSvart,
  belteBla,
  paraplyer,
  rengjoring1
];

export const getCategoryById = (id: string): TilbehorCategory | undefined => {
  return tilbehorCategories.find(item => item.id === id);
};
